import { render, staticRenderFns } from "./MaterialLabelPrintRecordList.vue?vue&type=template&id=cb042c68&scoped=true&"
import script from "./MaterialLabelPrintRecordList.vue?vue&type=script&lang=js&"
export * from "./MaterialLabelPrintRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb042c68",
  null
  
)

export default component.exports